export class RentLine {
   constructor(operation, operation_id, sale_id, rentNumber, rentNames, rentInitTime, rentEndTime, rentTime, phoneNumber, rentType){
      this.operation = operation
      this.operation_id = operation_id
      this.sale_id = sale_id
      this.rentNumber = rentNumber
      this.rentNames = rentNames
      this.rentInitTime = rentInitTime
      this.rentEndTime = rentEndTime
      this.rentTime = rentTime
      this.phoneNumber = phoneNumber
      this.rentType = rentType
   } 
}